/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_5_PInputs */

const en_privacy_5_p = /** @type {(inputs: Privacy_5_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use strictly necessary cookies for your session, language and theme. Where enabled, Google Analytics and Microsoft Clarity collect anonymised usage data to help us understand how the product is used. You can block them with a browser extension without losing any functionality.`)
};

const id_privacy_5_p = /** @type {(inputs: Privacy_5_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami memakai cookie yang benar-benar diperlukan untuk sesi, bahasa, dan tema. Bila diaktifkan, Google Analytics dan Microsoft Clarity mengumpulkan data penggunaan anonim untuk membantu kami memahami cara produk dipakai. Kamu bisa memblokirnya dengan ekstensi browser tanpa kehilangan fungsi apa pun.`)
};

/**
* | output |
* | --- |
* | "We use strictly necessary cookies for your session, language and theme. Where enabled, Google Analytics and Microsoft Clarity collect anonymised usage data t..." |
*
* @param {Privacy_5_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_5_p = /** @type {((inputs?: Privacy_5_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_5_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_5_p(inputs)
	return en_privacy_5_p(inputs)
});